import React from "react";
import projectImage from "../../../assets/ShephedLaw/MainCaseStudiesPhoto.jpg";
import project1Image from "../../../assets/ShephedLaw/MainPage.png"; // Import your images
import project2Image from "../../../assets/ShephedLaw/AboutUs.png";
import project3Image from "../../../assets/ShephedLaw/MissionPage.png";
import Footer from "../../../components/Footer";
import Navbar from "../../../components/Navbar";
import NavLite from "../../../components/NavLite";
import PastWork from "../../../components/PastWord";

function ShepherdLaw() {
  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1]">
      <title>Website Case Study: Shephed Law | Custom Design for Female Lawyers | Zilker Web Design</title>
      <meta
        name="description"
        content="View the Shephed Law website redesign—crafted by Zilker Web Design to elevate brand authority and SEO for a woman-led law firm"
      />
      <meta
        name="keywords"
        content="legal brand website design, web design for women attorneys, attorney website example, Shephed Law client spotlight, SEO for legal professionals, elegant branding for law firms, premium law site design"
      />

      <section className="bg-[#F7F3F2]">
        <div
          className="relative h-auto bg-cover bg-center"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${projectImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
         <NavLite/>
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex items-center justify-center">
              <h1 className="text-black italic text-3xl max-w-96 text-center bg-[#CFF098] font-semibold">
                Shepherd Law Group Website Design
              </h1>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2]">
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex flex-col items-center text-center">
              <h2 className="text-3xl font-regular md:text-5xl text-black max-w-2xl uppercase">
                Custom Website Design for Shepherd Law Group
              </h2>
              <p className="mb-8 mt-4 max-w-lg text-base text-black md:mb-12 md:text-lg font-light">
                A professional and trustworthy website that reflects the essence of Shepherd Law Group, blending modern design with an intuitive user experience.
              </p>
            </div>


<section>
  <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-6">
    <h2 className="mb-8 text-center text-3xl md:mb-12 md:text-5xl lg:mb-16 text-black">
      Our results
    </h2>
    <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-4 lg:gap-6">
      <div className="relative p-8 md:p-10">
        <h3 className="mb-4 text-3xl font-bold md:text-5xl text-black bg-[#CFF098] max-w-[120px] italic">40%</h3>
        <p className="text-sm text-black">
        Increase in organic search results - More visibility where it matters most.
        </p>
        <div className="absolute right-0 top-1/3 hidden h-2/5 border-r border-gray-300 md:block"></div>
      </div>
      <div className="relative p-8 md:p-10">
        <h3 className="mb-4 text-3xl font-bold md:text-5xl text-black bg-[#CFF098] max-w-[120px] italic">64%</h3>
        <p className="text-sm text-black">Of customers reported increased trust in businesses with a professional online presence, demonstrating the confidence it builds.
        </p>
        <div className="absolute right-0 top-1/3 hidden h-2/5 border-r border-gray-300 md:block"></div>
      </div>
      <div className="p-8 md:p-10">
        <h3 className="mb-4 text-3xl font-bold md:text-5xl text-black bg-[#CFF098] max-w-[120px] italic">70%</h3>
        <p className="text-sm text-black">
        Increase in phone calls - Direct impact on lead generation and business growth!
        </p>
      </div>
    </div>
  </div>
</section>


            {/* Portfolio Items with Image on Left and Text on Right */}
            <div className="space-y-16 mt-4">
              {/* Project 1: Image on Left, Text on Right */}
              <div className="flex flex-col-reverse md:flex-row items-center md:space-x-8">
                <div className="flex-1">
                  <img
                    src={project1Image}
                    alt="Shepherd Law Homepage"
                    className="w-full h-auto"
                  />
                </div>
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-xl font-semibold text-black mt-4 md:mt-0">Homepage Redesign</h3>
                  <p className="text-black text-lg font-light mt-4">
                  This project commenced when Shepherd Law Group reached out to us to create a WordPress website. Following a one-hour design consultation, we collaboratively established the site's overarching design, aesthetics, and code. The client was undergoing a rebranding effort and sought a website that would convey a sense of trust and confidence to their customers, characterized by a clean and concise design.


                  </p>
                </div>
              </div>

              {/* Project 2: Image on Right, Text on Left */}
              <div className="flex flex-col md:flex-row-reverse items-center md:space-x-8 mt-4">
                <div className="flex-1">
                  <img
                    src={project2Image}
                    alt="Shepherd Law About Us Page"
                    className="w-full h-auto"
                  />
                </div>
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-xl font-semibold text-black mt-4 md:mt-0">About Us Page</h3>
                  <p className="text-black text-lg font-light mt-4">
                  We followed the Halo Effect in my design of the "About Us Page" and made it look as professional as the others pages. If users have a good first impression, the positive feelings permeate to other parts of the site.
                  </p>
                </div>
              </div>

              {/* Project 3: Image on Left, Text on Right */}
              <div className="flex flex-col-reverse md:flex-row items-center md:space-x-8">
                <div className="flex-1 mt-4">
                  <img
                    src={project3Image}
                    alt="Shepherd Law Mission Page"
                    className="w-full h-auto object-fill"
                  />
                </div>
                <div className="flex-1 text-center md:text-left mt-4">
                  <h3 className="text-xl font-semibold text-black mt-4 md:mt-0">Mission Statement</h3>
                  <p className="text-black text-lg font-light mt-4">
                  <ul className="list-disc pl-6 text-gray-800">
  
      This client wanted to display their core value of 'trust'
      <li className="mb-1">
        <strong>Organizational goals shift:</strong> Reflect new objectives to keep design efforts focused.
      </li>
      <li className="mb-1">
        <strong>Industry trends change:</strong> Adapt to emerging technologies and user expectations.
      </li>
      <li className="mb-1">
        <strong>Team dynamics evolve:</strong> Accommodate new members or leadership changes.
      </li>
      <li>
        <strong>User needs expand:</strong> Stay responsive to shifting user preferences and requirements.
      </li>
    </ul>
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mt-16">
              <a
                href="/contact"
                className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black uppercase"
              >
                START A PROJECT →
              </a>
              <p className="text-black text-lg font-light mt-6 w-[400px] text-center">
                Ready to enhance your online presence? Let's discuss your project today.
              </p>
            </div>
          </div>
        </section>
        <PastWork/>

        <Footer />
      </section>
    </main>
  );
}

export default ShepherdLaw;
